import * as React from 'react';
import { createPortal } from 'react-dom';

import { ModalContent } from './ModalContent';
import { ModalOverlay } from './ModalOverlay';

import { useModal } from '../../../hooks/useModal';
import { useBodyNoScroll } from '../../../hooks/useBodyNoScroll';
import { useRestoreScrollPosition } from '../../../hooks/useRestoreScrollPosition';

interface ModalWrapperContentProps {
  hideOverlay: boolean;
}

const ModalWrapperContent: React.FC<ModalWrapperContentProps> = React.memo(
  ({ hideOverlay }) => {
    return (
      <>
        <ModalContent />
        {!hideOverlay ? <ModalOverlay /> : null}
      </>
    );
  }
);

const Modal: React.FC = React.memo(() => {
  const { show, hideOverlay } = useModal();
  useBodyNoScroll(show);
  useRestoreScrollPosition({ condition: show });

  if (typeof document !== 'undefined' && show) {
    const mount = document.getElementById('portal');
    if (!mount) throw new Error('no mount div found for modal');
    return createPortal(<ModalWrapperContent hideOverlay={hideOverlay} />, mount);
  }
  return null;
});

export default Modal;
